import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../form/element/button';

import I18n from '@app/modules/i18n';
import ActionBar from '@component/info/actionbar';
import { Alert, ALERT_TYPES } from '@component/alert';

const BASE_CLASS_NAME = 'cookie-manager-clear';

const CookieManagerClear = ({ loggedIn }) => {
  const [showActionBar, setShowActionBar] = React.useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowActionBar(true);
  };
  const handleConfirm = () => window.location.assign('/cookies/clear');
  const handleCancel = () => setShowActionBar(false);

  return (
    <React.Fragment>
      <form className={BASE_CLASS_NAME} onSubmit={handleSubmit}>
        <h3 className={`${BASE_CLASS_NAME}__title`}>
          {I18n.t('transfer.cookie-manager.clear.title')}
        </h3>
        <p
          className={`${BASE_CLASS_NAME}__description legal__rich-text`}
          dangerouslySetInnerHTML={{
            __html: I18n.t('transfer.cookie-manager.clear.description'),
          }}
        />
        {loggedIn && (
          <Alert
            text={I18n.t('transfer.cookie-manager.clear.warning')}
            type={ALERT_TYPES.WARNING}
            icon="Error"
          />
        )}
        <Button
          submit
          type="inline"
          text={I18n.t('transfer.cookie-manager.clear.clear-all-cookies')}
          className={`${BASE_CLASS_NAME}__submit`}
        />
      </form>
      <ActionBar
        text={I18n.t('page.about.legal.actionbar.text')}
        hidden={!showActionBar}
      >
        <Button
          type="actionbar-action"
          text={I18n.t('transfer.buttons.cancel_yes')}
          onClick={handleConfirm}
        />
        <Button
          type="actionbar-cancel"
          text={I18n.t('page.transfer_progress.upsell.button.cancel')}
          onClick={handleCancel}
        />
      </ActionBar>
    </React.Fragment>
  );
};

CookieManagerClear.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

export default CookieManagerClear;
